import PropTypes from 'prop-types'

const CreatedByCell = ({ cell }) => {
  if (!cell.value) return ''
  const { firstName, lastName } = cell.value
  return `${firstName || ''} ${lastName || ''}`.trim()
}

CreatedByCell.propTypes = {
  cell: PropTypes.object
}
export default CreatedByCell
